module.exports = __webpack_public_path__ + "img/tarot-escudo-bajo.06155fae.svg";